import * as React from 'react';
import { useForm } from 'react-typed-form';

import { Api, useApiFormSubmit } from '../../api';
import { Button } from '../../components';
import {
  FieldText,
  FieldTextRequired,
  FormWrap,
  SubmitButton,
} from '../../form';

type Props = {
  companyId: string;
  invalidate: () => unknown;
};

export default function CreateReleaseForm({ companyId, invalidate }: Props) {
  const [formVisible, setFormVisible] = React.useState(false);

  const onSubmit = useApiFormSubmit('POST', '/releases', { invalidate });
  const form = useForm<Api.Release.W_Create>({
    defaultValues: {
      company: `/companies/${companyId}`,
      platform: null,
      versionNumber: '',
    },
    onSubmit,
  });

  if (!formVisible) {
    return <Button label="New release" onClick={() => setFormVisible(true)} />;
  }

  return (
    <FormWrap {...form}>
      <FieldTextRequired field={form.getField('versionNumber')} />
      <FieldText field={form.getField('platform')} />
      <SubmitButton {...form} label="Submit" />
    </FormWrap>
  );
}
